<template>
    <div id="credentialsAudit" class="background-ash pl20 pr20 pb20">
        <!--内容-->
        <div class="content">
            <!--表头操作-->
            <div class="watchBar">
                <div class="left btns">
                    <el-button size="small" class="export-right" type="primary" plain @click="callback">返回</el-button>
                </div>
                <div class="right btns">
                    <!-- <el-button size="small" type="primary"  @click="save">保存</el-button> -->
                    <el-button size="small" class="export-right" type="primary" plain @click="downCredential">下载资质</el-button>
                </div>
            </div>
            <div class="tab">
                <el-table ref="checkList" size="mini" :data="dataList" tooltip-effect="dark" height="100%">
                   <el-table-column label="资质类型" prop="certificateName"></el-table-column>
                   <el-table-column label="资质文件">
                        <template slot-scope="scope">
                            <div v-if="!scope.row.url" tabindex="0" class="el-upload el-upload--picture-card">
                                <i class="el-icon-plus"></i>
                                <input @change="chagneUploadImg($event,scope.row)" type="file" name="file" id="file" class="el-upload__input">
                            </div>
                            <ul v-else class="el-upload-list el-upload-list--picture-card">
                                <li tabindex="0" class="el-upload-list__item is-ready">
                                    <img @click="getDemo1(scope.row.url)" :src="scope.row.url" alt="" class="el-upload-list__item-thumbnail">
                                    <a class="el-upload-list__item-name"><i class="el-icon-document"></i></a>
                                </li>
                            </ul>
					        <p v-if="scope.row.url" style="position:relative;"><span style="color:#2480ED;cursor: point;">
                                重新上传</span>
                                <input @change="chagneUploadImg($event,scope.row)" type="file" name="file" id="file2" class="el-upload__input">
                            </p>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status==='UPLOAD'">上传</span>
                            <span v-else-if="scope.row.status==='INIT'">待审核</span>
                            <span v-else-if="scope.row.status==='PASS'">已通过</span>
                            <span v-else-if="scope.row.status==='FAILED'">未通过</span>
                            <span v-else-if="scope.row.status==='EXPIRE'">已过期</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="有效期">
                        <template slot-scope="scope">
                            {{scope.row.validStartDate}}-{{scope.row.validEndDate}}
                        </template>
                    </el-table-column>
                    <el-table-column label="更新时间" prop="gmtModified"></el-table-column>
                    <el-table-column label="操作" width="300">
                        <template slot-scope="scope" v-if="!!scope.row.url">
                            <el-button v-if="scope.row.status==='PASS'" type="text" @click="locking(scope.row)">锁定</el-button>
                            <el-button v-if="scope.row.status==='INIT' || scope.row.status==='FAILED'" type="text" @click="passThrough(scope.row)">通过</el-button>
                            <el-button v-if="scope.row.status==='INIT'" type="text" @click="noPassThrough(scope.row)">不通过</el-button>
                            <el-button type="text" @click="downSingle(scope.row)">下载资质</el-button>
                            <el-button type="text" @click="deleteCredential(scope.row)">删除资质</el-button>
                            <el-button type="text" @click="editTermValidity(scope.row)">编辑有效期</el-button>
                        </template>
                    </el-table-column>
               </el-table>
            </div>
        </div>
        <!--证件审核-->
        <el-dialog  :title="title" :visible.sync="certificateAuditDialog" class="nopad" width="390px" >
            <el-form :model="certificateAudit" :rules="rules" status-icon ref="ruleForm" label-width="92px" class="demo-ruleForm">
                <el-form-item label="证件有效期" v-if="detail.btn==='pass' || detail.btn==='validity'" prop="time1">
                    <el-date-picker class="audit" size="small" v-model="certificateAudit.time1" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="备注" class="last-form-item" v-if="detail.btn!=='validity'" prop="auditMemo">
                    <el-input v-model.trim="certificateAudit.auditMemo"  type="textarea" class="width275" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="certificateAuditDialog = !certificateAuditDialog">取 消</el-button>
                <el-button size="small" type="primary" @click="confirmAudit">
                    <span v-if="detail.btn==='pass'">确认通过</span>
                    <span v-else-if="detail.btn==='noPass'">确认不通过</span>
                    <span v-else-if="detail.btn==='locking'">锁定</span>
                    <span v-else>保存</span>
                </el-button>
            </span>
        </el-dialog>
            <div class="bigImg1" v-show="isShowImg">
            <div class="bg1" @dblclick="resizeImage($event)">
                <img @mousedown="move($event)" :style="css" src="./../../assets/img/login2.png" id="img" />
            </div>
            <div class="myDiv">
                <img src="./../../assets/img/zoom-in.png" @click="biggerImage()" >
                <img src="./../../assets/img/zoom-out.png"  @click="smallerImage()">
                <img src="./../../assets/img/revision1.png" @click="imgRotateRight()" >
                <img src="./../../assets/img/revision2.png" @click="imgRotateLeft()" >
                <img src="./../../assets/img/collapse.png"  @click="resizeImage()">
                <img src="./../../assets/img/right.png" @click="preImg()" class="pre-img"/>
                <img src="./../../assets/img/right.png" @click="nextImg()" class="next-img"/>
                <img src="./../../assets/img/close1.png" @click="closeImg" class="close1"/>
            </div>
        </div>
    </div>
</template>

<script>
//获取bg的高和宽
let bg = null,
    bgw = 0,
    bgh = 0,     
    bigImg = null,
    wdW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    wdH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
let current = 0, arrayImg = [];
export default {
	name: 'credentialsAudit',
	data () {
		return {
            dataList:[],
			getDataParam: {
               id: null
            },
            title: '证件审核',
            imgUrl: '',
            certificateAuditDialog: false,
            certificateAudit: {
                time1: '',
                auditMemo:''
            },
            detail: {},
            rules:{
				time1: [{ required: true, message: '请选择时间', trigger: 'change' }],
				auditMemo: [{ required: true, message: '请输入备注', trigger: 'blur' }]			
            },
            isShowImg: false,
            css: {}
		}
	},
	watch: {
        certificateAuditDialog(val){
            if (!val) {                
                this.certificateAudit.time1 = '';
                this.certificateAudit.auditMemo = '';
                this.$refs.ruleForm.resetFields();
            }
        }	
	},
	methods: {
		getDataList () {
            const loading = this.load();
            this.$http('POST', '/admin/user/certificate/get', {}, {id: this.getDataParam.id} , (statu, res) => {       
                loading.close();         
                if (statu) {
                    if(!!res.data && res.data.length > 0) {
                       this.dataList = res.data;
                       res.data.forEach( (item) => {
                           if ( !!item.url ) {
                               arrayImg.push(item.url);
                           }
                       })
                       arrayImg.push()
                   }else {
                       this.dataList = [];
                   }
                }
            })
        },
        chagneUploadImg (dom,item) {
			if (!!dom.target.files) {
				let file = dom.target.files[0];			
				const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('上传课程封面图只能是 JPG或png 格式!');
					return false;
				}
				if (!isLt5M) {
					this.$message.error('上传课程封面图大小不能超过 5MB!');
					return false;
				}
				this.uploadImg(dom,'CERTIFICATE', (status,res) => {
					if (status) {
                        this.$http('POST', '/admin/user/certificate/upload', {}, {
                            userId: this.getDataParam.id,
                            certificateCode: item.certificateCode,
                            path: res.data.relative
                        }, (statu, resq) => {
                            if (statu) {
                                this.getDataList();
                            }
                        })
					}
				});				
			}
        },         
        //通过
        passThrough (item) {
            this.title = '证件审核';
            this.detail = item;
            this.detail.btn = 'pass';
            this.certificateAuditDialog = true;           
        },  
        //不通过
        noPassThrough (item) {
            this.title = '证件审核';
            this.detail = item;
            this.detail.btn = 'noPass';
            this.certificateAuditDialog = true;
        },
        //锁定
        locking (item) {
            this.title = '证件审核';
            this.detail = item;
            this.detail.btn = 'locking';
            this.certificateAuditDialog = true;
        },
        //编辑有效期
        editTermValidity (item) {
            this.title = '编辑有效期';
            this.detail = item;
            this.detail.btn = 'validity';
            this.certificateAuditDialog = true;
        },       
        //下载资质
        downCredential () {
            const loading = this.loading();
            this.$http('POST', '/admin/user/certificate/download', {}, {id: this.getDataParam.id} , (statu, res) => {       
                loading.close();         
                if (statu) {
                   if (res.status === '200') {
                       this.educe(res.data);
                   }
                }
            })
        },
        //返回列表
        callback () {
            this.$router.back(-1);
        },
        //下载单个资质 
        downSingle (item) {
            window.location.href = item.url;
        },
        //删除资质
        deleteCredential (item) {
            this.$confirm(`是否删除【${item.certificateName}】资质?`, '提示', {confirmButtonText: '确定', cancelButtonText: '取消'}).then(() => {
                console.log('删除有效期..............');
                this.$http('post', '/admin/user/certificate/delete', {}, {id: item.id}, (statu, data) => {
                    if (statu) {
                        this.$message({message: '删除成功', type: 'success'});
                        this.getDataList();
                    }                    
                })
            }).catch(() => {})
        },
        //资质审核
        confirmAudit () {
            this.$refs.ruleForm.validate( (check) => {
                if (check) {
                    if (this.detail.btn === 'pass' || this.detail.btn === 'noPass') {
                        //资质审核
                        let param = {
                            id: this.detail.id,
                            validStartDate: '',
                            validEndDate: '',
                            status:'',
                            auditMemo: this.certificateAudit.auditMemo
                        };
                        if (!!this.certificateAudit.time1 && this.certificateAudit.time1.length > 0) {
                            param.validStartDate = this.$root.format(this.certificateAudit.time1[0]);
                            param.validEndDate = this.$root.format(this.certificateAudit.time1[1]);
                        } else {
                            param.validStartDate = "";
                            param.validEndDate = "";
                        }
                        param.status = (this.detail.btn === 'pass' ? 'PASS' : 'FAILED');                        
                        const loading = this.load();
                        this.$http('POST', '/admin/user/certificate/verify', {}, param , (statu, res) => {       
                            loading.close();                            
                            if (statu) {
                                this.certificateAuditDialog = false;  
                                this.$message({message: '审核成功', type: 'success'});
                                this.getDataList();
                            }
                        })
                    } else if (this.detail.btn === 'locking') {
                        //锁定
                        const loading = this.load();
                        this.$http('POST', '/admin/user/certificate/lock', {}, {id: this.detail.id, memo: this.certificateAudit.auditMemo} , (statu, res) => {       
                            loading.close();         
                            if (statu) {
                                this.certificateAuditDialog = false;
                                this.$message({message: '锁定成功', type: 'success'});
                                this.getDataList();
                            }
                        })
                    } else if (this.detail.btn === 'validity') {
                        //编辑有效期
                        let param = {
                            id: this.detail.id,
                            validStartDate: '',
                            validEndDate: ''                 
                        };
                        if (!!this.certificateAudit.time1 && this.certificateAudit.time1.length > 0) {
                            param.validStartDate = this.$root.format(this.certificateAudit.time1[0]);
                            param.validEndDate = this.$root.format(this.certificateAudit.time1[1]);
                        } else {
                            param.validStartDate = "";
                            param.validEndDate = "";
                        }
                        const loading = this.loading();
                        this.$http('POST', '/admin/user/certificate/editExpiry', {}, param , (statu, res) => {       
                            loading.close();     
                            this.certificateAuditDialog = false;    
                            if (statu) {
                                this.$message({message: '编辑有效期成功', type: 'success'});
                                this.getDataList();
                            }
                        })
                    }
                }
            });            
        },
        //图片功能        
        getDemo1 (src) {
            var src=src,
                newimg = new Image();
            newimg.src = src;
               let _this = this;
            newimg.onload = function (){
                var imgW = newimg.width*1,
                    imgH = newimg.height*1;
                bigImg.src = src; 
                if (imgW < wdW && imgH < wdH) {
                        _this.css = {width: imgW, height: imgH, left: '50%', top: '50%', transform: 'translate(-50%, -50%) rotate(0)'};
                } else {
                    if (imgW/imgH >= wdW/wdH) {
                         _this.css = {width: '100%', height: 'auto', left: '50%', top: '50%', transform: 'translate(-50%, -50%) rotate(0)'};
                    } else if (imgW/imgH <= wdW/wdH) {
                            _this.css = {width: 'auto', height: '100%', left: '50%', top: '50%', transform: 'translate(-50%, -50%) rotate(0)'};
                    } else {
                            _this.css = {width: '100%', height: '100%', left: '50%', top: '50%', transform: 'translate(-50%, -50%) rotate(0)'};
                    }
                }
                _this.isShowImg = true;
            }
        },
        mouseWheelScroll () {
            var _delta = parseInt(event.wheelDelta || -event.detail);
            //向上滚动
            if (_delta > 0) {
                this.biggerImage();
            }
            //向下滚动
            if(_delta < 0){
                this.smallerImage();
            }
            return false;
        },
        biggerImage () {
            var w = bigImg.offsetWidth,
                h = bigImg.offsetHeight,
                rodie=1.2,
                nextW = w * rodie ,
                nextH = h * rodie,
                percent;
            percent=(nextW / w * 100).toFixed(0);
            if(percent > 90 && percent < 110){
                percent = 100;
                nextW = w;
                nextH = h;
            }
            else if(percent > 1600) {
                percent = 1600;
                nextW = w * 16;
                nextH = h * 16;
            }
            this.css = {width: nextW+'px', height: nextH+'px', left: '50%', top: '50%'};
            this.setImagePosition()
        },
        smallerImage () {
            var w = bigImg.offsetWidth,
                h = bigImg.offsetHeight,
                rodie=1.2,
                nextW, nextH;
            var percent =  (w / rodie).toFixed(0);
            if(percent < 5) {
                percent = 5;
                nextW = w / 20;
                nextH = h / 20;
            }
            else if(percent > 90 && percent < 110){
                percent = 100;
                nextW = w;
                nextH = h;
            } else{
                nextW = w / rodie;
                nextH = h / rodie;
            }
            this.css = {width: nextW+'px', height: nextH+'px', left: '50%', top: '50%'};
            this.setImagePosition()
        },
        setImagePosition () {
            bgw = bg.offsetWidth;
            bgh = bg.offsetHeight;
            var w = this.css.width.split('p')[0],
                h = this.css.height.split('p')[0];
            console.log('bgw........',bgw,bigImg.offsetWidth,w);
            var left = (bgw - w)/2,
                top = (bgh - h)/2;
            this.css.left = left +"px";
            this.css.top = top +"px";
        },
        resizeImage () {
            var url=bigImg.getAttribute("src");
            this.getDemo1(url);
        },
        imgRotateLeft () {
            current += 90;
            if (current == 360 || current == -360) {
                current = 0;
            }
            this.css.transform = 'translate(-50%, -50%) rotate(' + current + 'deg)';
        },
        imgRotateRight () {
            current -= 90;
            if (current == 360 || current == -360) {
                current = 0;
            }
            this.css.transform = 'translate(-50%, -50%) rotate(' + current + 'deg)';
        },
        move (e,) {
            var odiv = e.target; //获取目标元素
                //算出鼠标相对元素的位置
                var disX = e.clientX - odiv.offsetLeft;
                var disY = e.clientY - odiv.offsetTop;
                document.onmousemove = (e) => {
                    //鼠标按下并移动的事件
                    var left = e.clientX - disX; //移动的距离
                    var top = e.clientY - disY; //移动的距离
                    //移动当前元素
                    this.css.left = left + 'px';
                    this.css.top = top + 'px';       
                };                
                document.onmouseup = (e) => {
                    document.onmousemove = null;
                    document.onmouseup = null;
                }
        },
        preImg:function(){
            var nowImgSrc = bigImg.getAttribute("src");
            for(var i=0;i<arrayImg.length;i++){
                if(nowImgSrc==arrayImg[i]){
                    if(i==0){
                        this.$message({message: '这是第一张', type: 'error'});
                    }else{
                        bigImg.src = arrayImg[i-1];
                        this.resizeImage();
                    }
                }
            }
        },
        nextImg:function(){
            var nowImgSrc = bigImg.getAttribute("src");
            for(var i=0;i<arrayImg.length;i++){
                if(nowImgSrc==arrayImg[i]){
                    if(i==(arrayImg.length-1)){
                        this.$message({message: '这是最后一张', type: 'error'});
                    }else{
                        bigImg.src = arrayImg[i+1];
                        this.resizeImage();
                    }
                }
            }
        },
        closeImg:function(){
            this.isShowImg = false;
            this.css.left = '0px';
            this.css.top = '0px';
            this.css.transform = 'rotate(' + current + 'deg)';           
            current=0;
        }
	},
	mounted () {
        this.imgUrl = this.$root.imgUrl+'/';
        this.getDataParam.id = this.$route.query.id;
        this.getDataList();
        this.$nextTick( () => {
            bg = document.getElementsByClassName('bg1')[0];
            bgw = bg.offsetWidth;
            bgh = bg.offsetHeight;
            bigImg = document.getElementById('img');
        })
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#credentialsAudit {width: 100%;height: calc(100vh - 132px);}
#credentialsAudit .content {height: 100%;}
#credentialsAudit .content .tab {height: calc(100% - 125px);}
#credentialsAudit >>>.width275.el-input{ height: 36px; border-radius: 2px;}
#credentialsAudit >>>.width275.el-input .el-input__inner{ height: 36px; border-radius: 2px; width: 230px;}
#credentialsAudit >>>.el-range-editor--small.el-input__inner.audit{height: 36px; width: 230px;}
#credentialsAudit >>>.el-dialog__wrapper.nopad .el-dialog__body{padding: 10px 20px;}
#credentialsAudit>>>.el-upload--picture-card{position: relative;}
#credentialsAudit #file{position: absolute; display: block; width: 148px; height: 148px; top: 0; left: 0; opacity: 0;}
#credentialsAudit #file2{position: absolute; display: block; width: 148px; height: 14px; top: 0; left: 0; opacity: 0;cursor: pointer;}

/*图片弹窗放大，缩小，旋转，等操作*/
.bigImg1{position: fixed;left: 0;top: 0;z-index: 11;width: 100%;height: 100%;background: url('./../../assets/img/black30.png') repeat;}
.bigImg1 .bg1{ width: 100%;height: 100%;position: relative;}
.bigImg1 .bg1 img{position: absolute;margin:0;padding: 0;}
.myDiv{height: 54px;width: 417px;border-radius: 15px;background: #989898;position: fixed;bottom: 0;left: 40%;}
.myDiv img{height: 50%;float: left;padding-left: 26px;margin-top: 15px;}
.myDiv .pre-img{transform: rotate(180deg);padding-left: 0;margin-left: 21px;}
.imgBody{width: 100%;height: 100%;position: fixed;left: 0;top: 0;background: rgba(0,0,0,.7);z-index: 1000;display: none;}
.imgBody img{position: absolute;left: 50%;top: 50%;transform: translate(-50% ,-50%);z-index: 1001;}
.imgBody span{width: 30px;height: 30px;line-height: 30px;z-index: 1001;cursor: pointer;;font-weight: bold;text-align: center;font-size: 24px;background: rgba(255,255,255,.8);color: #666;font-family: simsun;font-style: normal;position: absolute;border-radius: 50%;}
.imgBody span:hover{background: rgba(255,255,255,1);}
.imgBody .prve{left: 20px;top: 50%;}
.imgBody .next{right: 20px;top: 50%;}
</style>



// WEBPACK FOOTER //
// src/views/user/credentialsAudit.vue